// extracted by mini-css-extract-plugin
export default {"description":"CreateOrRecommend_description__yhGB4"};